module.exports = __webpack_public_path__ + "static/hospitaalbroeders-logo-544b550df0091a54606e40005d878afb.svg";